<template>
  <div class="row mx-3 justify-content-start">
    <span class="form-label align-self-start size-12 p-0">スキル</span>
    <div class="row m-0 p-0 gap-2">
      <div
        v-for="(skill, idx) in props.skills.flatMap((category) =>
          category.children?.map((children) => ({ categoryName: category.name, children }))
        )"
        :key="skill?.children.id"
        class="mb-2 d-flex align-items-center col-auto p-0"
      >
        <Field :id="`candidate_resume_skills_${idx}`" :name="`candidate_resume_skills[${idx}]`">
          <p class="bg-silver-primary px-3 py-1 mb-0 border border-fourth rounded-2">
            {{ skill?.children.name }}
          </p>
          <span class="ms-2">
            <img
              src="@/assets/image/icon-close-delete.svg"
              role="button"
              class="border rounded-circle border-third p-0d25"
              @click="onRemoveSkill(skill?.children.id)"
            />
          </span>
        </Field>
      </div>
    </div>
    <div class="col-md-12 d-flex justify-content-center mt-2">
      <AddButton class="mw-184x" title="スキルを追加する" @click="addSkill" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Field } from 'vee-validate';
import AddButton from '@/components/common/Button/AddButton/index.vue';

const onRemoveSkill = (id: number): void => {
  emit('remove', id);
};

const addSkill = (): void => {
  emit('open');
};

const props = defineProps({
  skills: {
    type: Array as unknown as () => any,
    required: false,
  },
});

const emit = defineEmits(['open', 'remove']);
</script>
